import { Middleware } from "redux";

import { AbsoluteResolvedModelPath, createFromMask, PathTokens } from "../../../../../../Common/ModelPath/ModelPath";
import { ModelChangeHooks } from "../../../Form/ModelChangeEventListener";
import { ViewModel } from "../../CoreTypes";
import { ModelActionType } from "../../ModelStoring/Store/modelActions";
import { CandyDispatch, CandyThunkAction } from "../CandyReduxTypes";
import { FullFormAction } from "../FullFormAction";

const findPathInHooks = (hooks: ModelChangeHooks, targetPath: AbsoluteResolvedModelPath, viewModel?: ViewModel) =>
    hooks.entries().flatMap(([listener, pathList]) =>
        pathList.map(bindingPath => {
            const modelPath = createFromMask(bindingPath, "auto", PathTokens.current);
            return modelPath.isIncludes(targetPath)
                ? {
                      listener: listener,
                      path: targetPath,
                      viewModel: viewModel,
                  }
                : undefined;
        })
    );

function processModelChangeEventHooks(hooks: ModelChangeHooks, action: FullFormAction | CandyThunkAction) {
    if ("type" in action && action?.type === ModelActionType.SetValues) {
        const deletedTargets = Iterator.from(action.payload.deleted).flatMap(deletedPath =>
            findPathInHooks(hooks, deletedPath, undefined)
        );
        const valuesTargets = Iterator.from(action.payload.values.iterateEntries()).flatMap(
            ([payloadPath, viewModel]) => findPathInHooks(hooks, payloadPath, viewModel)
        );
        for (const notifyTarget of deletedTargets) {
            if (notifyTarget) {
                notifyTarget.listener({
                    path: notifyTarget.path.toLegacyPath(),
                    value: notifyTarget.viewModel?.value ?? "",
                    type: "remove",
                });
            }
        }
        for (const notifyTarget of valuesTargets) {
            if (notifyTarget) {
                notifyTarget.listener({
                    path: notifyTarget.path.toLegacyPath(),
                    value: notifyTarget.viewModel?.value ?? "",
                    type: "change",
                });
            }
        }
    }
}

export const modelChangeHookMiddleware = (form: IForm): Middleware => {
    const result =
        () =>
        (next: CandyDispatch): CandyDispatch =>
        (action: FullFormAction | CandyThunkAction) => {
            processModelChangeEventHooks(form.getBeforeModelChangeEventListenerHooks(), action);
            // @ts-ignore
            const res = next(action);
            processModelChangeEventHooks(form.getModelChangeEventListenerHooks(), action);
            return res;
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
    return result as any;
};
